import React from "react";
import { Link } from "react-router-dom";
import { Building2, Users, Shield, Target } from "lucide-react";

const publicEmail = process.env.REACT_APP_CONTACT_EMAIL?.trim();

export default function About() {
  return (
    <div className="premium-page-surface max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-6">About Us</h1>
      
      <div className="prose prose-lg max-w-none">
        <p className="text-muted-foreground text-lg mb-8">
          We are India's premium real estate marketplace, connecting property buyers, 
          sellers, agents, and offices through a modern, transparent, and technology-driven platform.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="premium-card premium-card-interactive p-6 border rounded-2xl hover:-translate-y-0.5 transition-all duration-200 group">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 ring-1 ring-primary/10 text-primary mb-3 shadow-sm group-hover:scale-110 group-hover:-rotate-3 transition-all duration-300 animate-gradient-pan"><Building2 className="h-6 w-6 group-hover:animate-icon-bob" /></span>
            <h3 className="text-lg font-semibold mb-2">Premium Listings</h3>
            <p className="text-muted-foreground">
              Browse published property and land listings using location, price,
              category, and property-detail filters.
            </p>
          </div>
          <div className="premium-card premium-card-interactive p-6 border rounded-2xl hover:-translate-y-0.5 transition-all duration-200 group">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 ring-1 ring-primary/10 text-primary mb-3 shadow-sm group-hover:scale-110 group-hover:-rotate-3 transition-all duration-300 animate-gradient-pan"><Users className="h-6 w-6 group-hover:animate-icon-bob" /></span>
            <h3 className="text-lg font-semibold mb-2">Trusted Network</h3>
            <p className="text-muted-foreground">
              Browse registered offices and agents whose verification state is
              shown clearly on their profile.
            </p>
          </div>
          <div className="premium-card premium-card-interactive p-6 border rounded-2xl hover:-translate-y-0.5 transition-all duration-200 group">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 ring-1 ring-primary/10 text-primary mb-3 shadow-sm group-hover:scale-110 group-hover:-rotate-3 transition-all duration-300 animate-gradient-pan"><Shield className="h-6 w-6 group-hover:animate-icon-bob" /></span>
            <h3 className="text-lg font-semibold mb-2">Secure & Private</h3>
            <p className="text-muted-foreground">
              Private owner data is excluded from public property responses, and
              operational contact access follows the signed-in workflow.
            </p>
          </div>
          <div className="premium-card premium-card-interactive p-6 border rounded-2xl hover:-translate-y-0.5 transition-all duration-200 group">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 ring-1 ring-primary/10 text-primary mb-3 shadow-sm group-hover:scale-110 group-hover:-rotate-3 transition-all duration-300 animate-gradient-pan"><Target className="h-6 w-6 group-hover:animate-icon-bob" /></span>
            <h3 className="text-lg font-semibold mb-2">Guided Discovery</h3>
            <p className="text-muted-foreground">
              Use recommendations, comparisons, saved listings, and site-visit
              requests to keep property decisions organized.
            </p>
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
        <p className="text-muted-foreground mb-6">
          To make property discovery, comparison, and visit coordination organized,
          transparent, and accessible across devices.
        </p>

        <h2 className="text-2xl font-bold mb-4">What We Offer</h2>
        <ul className="list-disc pl-6 space-y-2 text-muted-foreground mb-6">
          <li>Guided property listing workflows for supported account roles</li>
          <li>Buy, Rent, Commercial, PG/Hostel, Plots, Villas, Farm Houses</li>
          <li>Property recommendations and saved shortlists</li>
          <li>Site-visit requests with assignment and status tracking</li>
          <li>Property comparison tool (up to 5 properties)</li>
          <li>Plots on Demand — submit requirements and get matched</li>
          <li>Search by city, locality, project, builder, and listing details</li>
          <li>EMI calculator</li>
        </ul>

        <h2 className="text-2xl font-bold mb-4">Contact</h2>
        <p className="text-muted-foreground">
          Have questions? {publicEmail ? <>Reach us at{" "}<a href={`mailto:${publicEmail}`} className="text-primary hover:underline">{publicEmail}</a>.</> : <>Use the <Link to="/contact" className="text-primary hover:underline">contact form</Link>.</>}
        </p>
      </div>
    </div>
  );
}
